import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import * as configUtils from "../../../abstract/controller/utils/configUtils";
import * as systemUtils from "../../../abstract/controller/utils/systemUtils";
import { useYamlImport } from "../../../abstract/hook/useYamlImport";
import { getEndpointAI, getEndpointTomato } from "../../../abstract/redux/slice/endpointSlice";
import { ButtonDefault } from "../../ui/buttons/ButtonDefault";
import styles from "./AsideElementOptionsDev.module.scss";

function AsideElementOptionsDev() {
  const { loadFromFile, loadPredefinedModel } = useYamlImport();

  const _fileRef = useRef(null);

  const handleFileChange = (event) => {
    const _file = event.target.files && event.target.files[0];
    loadFromFile(_file);
    event.target.value = null;
  };

  const handleReset = () => {
    loadPredefinedModel("initial");

    systemUtils.clearSessionStorage();
    systemUtils.dispatchEvent("clearStorage");
  };

  return (
    <div className={styles["options"]}>
      <input
        style={{ display: "none" }}
        ref={_fileRef}
        type="file"
        accept=".yaml"
        onChange={handleFileChange}
      />
      <ButtonDefault text={"global reset"} handler={handleReset} shadow={false} wide />
      <ButtonDefault
        text={"model - initial"}
        handler={() => loadPredefinedModel("initial")}
        shadow={false}
        wide
      />
      <ButtonDefault
        text={"model - default"}
        handler={() => loadPredefinedModel("default")}
        shadow={false}
        wide
      />
      <ButtonDefault
        text={"model - workshop"}
        handler={() => loadPredefinedModel("workshop")}
        shadow={false}
        wide
      />
      <ButtonDefault
        text={"model - epic battle"}
        handler={() => loadPredefinedModel("epicBattle")}
        shadow={false}
        wide
      />
      <TextEndpointAI />
      <TextEndpointTomato />
      <EndpointAICheckbox name={"Force local endpoint (8080) - AI"} />
      <EndpointTomatoCheckbox name={"Force local endpoint (9000) - Tomato"} />
      <ConfigCheckbox name={"Send mock suggestions (uuid, offline)"} />
    </div>
  );
}

function TextEndpointAI() {
  const endpoint = useSelector(getEndpointAI);

  return (
    <>
      <div className={styles["text"]}>
        Endpoint - AI
        <input type="text" value={endpoint} disabled />
      </div>
    </>
  );
}

function TextEndpointTomato() {
  const endpoint = useSelector(getEndpointTomato);

  return (
    <>
      <div className={styles["text"]}>
        Endpoint - Tomato
        <input type="text" value={endpoint} disabled />
      </div>
    </>
  );
}

function ConfigCheckbox({ name }) {
  const [_isEnabled, _setEnabled] = useState(() => configUtils.getMockSuggestions());

  const handleOnChange = (e) => {
    const value = !_isEnabled;

    _setEnabled(value);
    configUtils.setMockSuggestions(value);
  };

  return (
    <label className={styles["checkbox"]}>
      <input type="checkbox" checked={_isEnabled} onChange={handleOnChange} />
      &nbsp;{name}
    </label>
  );
}

function EndpointAICheckbox({ name }) {
  const [_isEnabled, _setEnabled] = useState(() => configUtils.getEndpointLocalAI());

  const handleOnChange = (e) => {
    const value = !_isEnabled;

    _setEnabled(value);
    configUtils.setEndpointLocalAI(value);
  };

  return (
    <label className={styles["checkbox"]}>
      <input type="checkbox" checked={_isEnabled} onChange={handleOnChange} />
      &nbsp;{name}
    </label>
  );
}

function EndpointTomatoCheckbox({ name }) {
  const [_isEnabled, _setEnabled] = useState(() => configUtils.getEndpointLocalTomato());

  const handleOnChange = (e) => {
    const value = !_isEnabled;

    _setEnabled(value);
    configUtils.setEndpointLocalTomato(value);
  };

  return (
    <label className={styles["checkbox"]}>
      <input type="checkbox" checked={_isEnabled} onChange={handleOnChange} />
      &nbsp;{name}
    </label>
  );
}

export default AsideElementOptionsDev;
